<template>
  <transition name="fade" appear>
    <div class="bottomhints" :style="{ height: `${height}px`, minHeight }">
      <div class="hint-body">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  .bottomhints {
    font-family: $hintFontFamily;
    font-family: $hintFontFamily-portal;
    position: absolute;
    bottom: 0;
    color: $inputHintColor;
    color: $inputHintColor-portal;
    animation-duration: 0.3s;
    max-height: 50%;
    font-size: $inputHintSize;
    font-size: $inputHintSize-portal;
    margin-bottom: 20px;
    width: 100%;
    z-index: 400;
    font-weight: $inputHintWeight;
    font-weight: $inputHintWeight-portal;
  }
</style>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'

  export default Vue.component('bottom-hints', {
    props: {
      minHeight: {
        type: String,
        default: '0vh'
      }
    },
    data () {
      return {
        actionKeyboard: false,
        content: false
      }
    },
    computed: {
      ...mapState(['app']),

      height () {
        let actionKeyboardHeight = this.actionKeyboard && document.querySelector('.actions') ? document.querySelector('.actions').clientHeight : false
        let contentHeight = this.content ? this.content.clientHeight : 0
        let ua = navigator.userAgent || ''
        let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
        let webkit = !!ua.match(/WebKit/i)
        let iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
        let bottomBarHeight = iOSSafari ? 44 : 0

        let hintHeight = (this.app.keyboardHeight || actionKeyboardHeight || 0) - bottomBarHeight + contentHeight
        return hintHeight
      }
    },
    methods: {
      detectActionKeyboard () {
        let detectKeyboards = setInterval(() => {
          if (!this.actionKeyboard && !this.app.keyboardHeight) {
            return this.calculateActionKeyboard()
          }
          return window.clearInterval(detectKeyboards)
        }, 100)
      },
      calculateActionKeyboard () {
        this.actionKeyboard = document.querySelector('.actions')
      },
      getHintContent () {
        this.content = document.querySelector('.hint-body')
      }
    },
    mounted () {
      this.detectActionKeyboard()
      this.getHintContent()
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/BottomHints.vue